// extracted by mini-css-extract-plugin
module.exports = {"root":"success-message_root__gZXAZ","icon":"success-message_icon__yNhtK"};